import React from "react";
import { Divider, Row } from "antd";
import { UploadIcon } from "../../../components/Image/Image";
import Text from "../../../components/Text/Text";
import color from "../../../resource/color";
import { UploadArea } from "./NewsStyled";

const previewImageStyle = {
  width: 280,
  height: 280,
};

interface Props {
  imgUrl?: string;
  topic: string;
  content: string;
  showTitle?: boolean;
  titleBar?: boolean;
}

export const NewsAppPreview: React.FC<Props> = ({
  imgUrl,
  topic,
  content,
  showTitle = true,
  titleBar = false,
}) => {
  const body = (
    <>
      <UploadArea style={previewImageStyle}>
        {imgUrl ? <img src={imgUrl} style={previewImageStyle} /> : UploadIcon}
      </UploadArea>
      <br />
      <Text level={4} fontWeight={700}>
        {topic}
      </Text>
      <Row>
        <Text level={6} color='Text3'>
          13 พ.ย. 2564, 12:00 น.
        </Text>
        &nbsp;&nbsp;
        <Text level={6} color='Text3'>
          อ่านแล้ว 0
        </Text>
      </Row>
      <Divider />
      <div
        className='view ql-editor'
        style={{
          display: "block",
          wordBreak: "break-word",
          wordWrap: "break-word",
        }}
        dangerouslySetInnerHTML={{ __html: content }}
      ></div>
    </>
  );

  if (titleBar) {
    return (
      <div
        style={{
          border: `1px solid ${color.background2}`,
          borderRadius: 8,
          overflow: "hidden",
        }}
      >
        <Row justify='center' style={{ background: color.grayishBlue, padding: "10px 16px" }}>
          <Text level={5} fontWeight={700} color='white'>
            ภาพตัวอย่างในแอปพลิเคชัน
          </Text>
        </Row>
        <div style={{ padding: 12, maxHeight: "90vh", overflowX: "hidden", overflowY: "auto" }}>
          {body}
        </div>
      </div>
    );
  }

  return (
    <>
      {showTitle && (
        <div
          style={{
            border: `1px solid ${color.background2}`,
            borderRadius: 8,
            overflow: "hidden",
          }}
        >
          <Row justify='center' style={{ background: color.grayishBlue, padding: "10px 16px" }}>
            <Text level={5} fontWeight={700} color='white'>
              ภาพตัวอย่างในแอปพลิเคชัน
            </Text>
          </Row>
          <div style={{ padding: 12, maxHeight: "90vh", overflowX: "hidden", overflowY: "auto" }}>
            {body}
          </div>
        </div>
      )}
    </>
  );
};

export default NewsAppPreview;
